import { useAuth } from '../contexts/AuthContext';

export const usePermission = () => {
    const { user, permissions } = useAuth();
    
    const hasPermission = (module, action = 'can_view') => {
        // Yönetici bypass
        if (user?.is_manager || user?.role === 'office_owner') return true;
        // Yetki kontrolü
        return permissions?.[module]?.[action] === true;
    };
    
    const canView = (module) => hasPermission(module, 'can_view');
    const canCreate = (module) => hasPermission(module, 'can_create');
    const canEdit = (module) => hasPermission(module, 'can_edit');
    const canDelete = (module) => hasPermission(module, 'can_delete');
    const canChangeStatus = (module) => hasPermission(module, 'can_change_status');
    const canShare = (module) => hasPermission(module, 'can_share');
    const canExport = (module) => hasPermission(module, 'can_export');
    const canViewAll = (module) => hasPermission(module, 'can_view_all');
    const canAssign = (module) => hasPermission(module, 'can_assign');
    
    return { 
        hasPermission, canView, canCreate, canEdit, canDelete, 
        canChangeStatus, canShare, canExport, canViewAll, canAssign 
    };
};
